import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../lib/api";
import { FadeUp } from "../components/Motion";
import LeadForm from "../components/LeadForm";

export default function ServiceDetail() {
  const { slug } = useParams();
  const [s, setS] = useState(null);

  useEffect(() => { api.get(`/services/${slug}`).then((r) => setS(r.data)).catch(() => setS(null)); }, [slug]);

  if (!s) return <div className="pt-32 px-6 text-[#D8D6D0]/40">Loading…</div>;

  return (
    <div data-testid="service-detail" className="pt-32 pb-32">
      <section className="px-6 md:px-12 lg:px-16">
        <FadeUp>
          <Link to={`/services/${s.category}`} className="overline text-[#8C1D30] mb-4 inline-block link-underline">← {s.category}</Link>
          <h1 className="font-serif-display text-5xl md:text-7xl lg:text-8xl leading-none max-w-5xl">
            {s.name}
          </h1>
        </FadeUp>
      </section>

      <section className="px-6 md:px-12 lg:px-16 mt-16">
        <FadeUp delay={0.1}>
          <div className="aspect-[16/8] overflow-hidden">
            <img src={s.image_url} alt={s.name} className="w-full h-full object-cover" />
          </div>
        </FadeUp>
      </section>

      <section className="px-6 md:px-12 lg:px-16 mt-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <FadeUp className="md:col-span-8">
          <p className="font-serif-display text-2xl md:text-3xl leading-snug text-[#F5F3EF]/95">{s.long_description}</p>
        </FadeUp>
        <FadeUp delay={0.1} className="md:col-span-4">
          <div className="nc-card p-8">
            <div className="overline text-[#D8D6D0]/50 mb-4">Start your project</div>
            <LeadForm leadType={s.category === "commercial" ? "commercial" : "residential"} source={`service-${s.slug}`} compact />
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
